export default function UseCases() {
  const cases = [
    {
      icon: 'ri-building-line',
      title: '中小企業オフィス',
      description: '日常的な書類作成から契約書の印刷まで、オフィスワークに必要な機能を網羅。コスト削減と業務効率化を同時に実現します。'
    },
    {
      icon: 'ri-store-2-line',
      title: '小売店舗',
      description: 'レシート印刷、在庫管理資料、販促物の作成など、店舗運営に欠かせない印刷業務をサポート。省スペース設計で場所を取りません。'
    },
    {
      icon: 'ri-hospital-line',
      title: '医療機関',
      description: 'カルテや処方箋、各種書類の印刷に対応。セキュリティ機能も充実しており、患者情報の保護も万全です。'
    },
    {
      icon: 'ri-tools-line',
      title: '建設現場事務所',
      description: '仮設事務所や現場詰所にも設置可能。工程表・図面・各種申請書類の印刷をスムーズにこなし、現場業務を強力にサポートします。'
    },
    {
      icon: 'ri-seedling-line',
      title: '創業期のコスト最小化',
      description: '本体料金0円だから、スタートアップや開業直後でも初期投資を抑えられます。月額定額制で資金計画も立てやすく、成長に合わせて柔軟に対応可能。'
    },
    {
      icon: 'ri-printer-line',
      title: '印刷量が少ない企業',
      description: '使った分だけのカウンター料金だから、印刷量が少なくても無駄なコストが発生しません。低頻度利用でもコストパフォーマンスに優れたプランをご用意。'
    }
  ];

  return (
    <section id="cases" className="py-24 bg-[#F5F1ED]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-16">
          <div className="text-xs text-gray-500 font-light mb-3 tracking-wider">USE CASE</div>
          <h2 className="text-5xl font-extrabold text-gray-900 leading-tight">
            <a href="#cases" className="hover:text-[#14B8A6] transition-colors cursor-pointer">
              様々なシーンで活躍する<br />
              複合機レンタル
            </a>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cases.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${item.icon} text-4xl text-gray-900`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {item.title}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
